import Administracao from "./Administracao";
import GestorProjetos from "./GestorProjetos";
import Suporte from "./Suporte";

export default {
  Administracao,
  GestorProjetos,
  Suporte,
};
